export default __webpack_public_path__ + "static/media/saoPauloHouse.2399ac1d.png";